// src/components/form/ReviewStep.js
import React, { memo } from "react";
import formatAnswer from "../../utils/form/formatAnswer";

/**
 * ReviewStep
 * ----------
 * Final read-only summary shown before form submission.
 *
 * Props
 * -----
 * • `questions` (array)  – The list of **filtered** questions in display order.
 * • `formData`  (object) – Answers keyed by question.id.
 *
 * Suggestions for further extraction
 * ----------------------------------
 * • Move `formatAnswer()` to `utils/formRuntime.js` so tests can cover all
 *   fieldTypes in one place (especially if you add new types).
 * • Replace inline `<div>` markup with a reusable <KeyValueRow/> component
 *   if multiple parts of the app need this two-column layout.
 */

/* ------------------------------------------------------------------ */
/* Main component                                                      */
/* ------------------------------------------------------------------ */
function ReviewStep({
  questions,
  formData,
  title = "Review Your Information",
}) {
  if (!Array.isArray(questions) || !questions.length) return null;

  return (
    <div className={`review-step space-y-4 w-full`}>
      <h2 className="text-xl font-bold">{title}</h2>

      <div className="space-y-2">
        {questions.map((q) => (
          <div
            key={q.id}
            className="flex justify-between border-b border-gray-200 pb-2"
          >
            <span className="font-semibold">{q.title}:</span>
            <span>{formatAnswer(q, formData)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(ReviewStep);
